import { Component, HostListener, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Bookpage, Dictionary } from '@pcp/core/interfaces';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { BookpageListComponent } from '../bookpage-list/bookpage-list.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

export interface BookpageListDialogData {
    bookpages?: Bookpage[];
    selectedBookpage: null | Bookpage;
}

@Component({
    selector: 'app-bookpage-list-dialog',
    templateUrl: './bookpage-list-dialog.component.html',
    styleUrls: ['./bookpage-list-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        BookpageListComponent,
        MatDialogActions,
        MatButton,
        MatIconButton,
        MatIcon,
        TranslocoPipe,
    ]
})
export class BookpageListDialogComponent {
    private _books: any;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: BookpageListDialogData,
        private dialogRef: MatDialogRef<BookpageListDialogComponent>
    ) {}

    @HostListener('document:keypress', ['$event'])
    handleEvent(event: KeyboardEvent): boolean {
        if (
            event instanceof KeyboardEvent &&
            event.key.toLowerCase() === 'enter' &&
            this.data.selectedBookpage
        ) {
            this.openBookpage(this.data.selectedBookpage);
            return false;
        }
        return true;
    }

    public get books(): Dictionary<Bookpage[]> {
        if (!this._books) {
            //pages grouped by book:
            const books: Dictionary<Bookpage[]> = {};
            if (!this.data.bookpages) return books;
            this._books = this.data.bookpages.reduce<Dictionary<Bookpage[]>>(
                (booksDict: Dictionary<Bookpage[]>, page: Bookpage) => {
                    if (!booksDict[page.book]) {
                        booksDict[page.book] = [];
                    }
                    booksDict[page.book].push(page);
                    return booksDict;
                },
                books
            );
        }
        return this._books;
    }

    public get bookNames() {
        return Object.keys(this.books);
    }

    public get selectedBookpage(): null | Bookpage {
        return this.data.selectedBookpage;
    }

    public openBookpage(page: Bookpage) {
        this.data.selectedBookpage = page;
        this.dialogRef.close(this.data);
    }

    public selectBookpage(page: Bookpage) {
        this.data.selectedBookpage = page;
    }

    public closeDialog() {
        this.dialogRef.close();
    }
}
